export const GET_CHECKOUT_INFO_REQUESTED = 'GET_CHECKOUT_INFO_REQUESTED';
export const GET_CHECKOUT_INFO_FAILURE = 'GET_CHECKOUT_INFO_FAILURE';
export const GET_CHECKOUT_INFO_SUCCESS = 'GET_CHECKOUT_INFO_SUCCESS';
export const FS_CHECKOUT_LOADED = 'FS_CHECKOUT_LOADED';
export const FS_CHECKOUT_ABORTED = 'FS_CHECKOUT_ABORTED';
export const FS_CHECKOUT_SUCCESS = 'FS_CHECKOUT_SUCCESS';
export const FS_CHECKOUT_FAILED_TO_LOAD = 'FS_CHECKOUT_FAILED_TO_LOAD';
export const FS_CHECKOUT_ERROR = 'FS_CHECKOUT_ERROR';
export const FS_CHANGE_SELECTED_PRODUCT = 'FS_CHANGE_SELECTED_PRODUCT';
export const FS_CLOSE_POPOVER_MODAL = 'FS_CLOSE_POPOVER_MODAL';
export const FS_LINK_OUT = 'FS_LINK_OUT';

export const getCheckoutInfo = () => ({
  type: GET_CHECKOUT_INFO_REQUESTED
});

export const getCheckoutInfoFailure = error => ({
  type: GET_CHECKOUT_INFO_FAILURE,
  error
});

export const getCheckoutInfoSuccess = (payload, licenceType, isDefaultPricing) => ({
  type: GET_CHECKOUT_INFO_SUCCESS,
  payload,
  licenceType,
  isDefaultPricing
});

export const fsCheckoutLoaded = ({ scribeId }) => ({
  type: FS_CHECKOUT_LOADED,
  scribeId
});

export const fsCheckoutAborted = () => ({
  type: FS_CHECKOUT_ABORTED
});

export const fsCheckoutSuccess = orderDetails => ({
  type: FS_CHECKOUT_SUCCESS,
  orderDetails
});

export const fsCheckoutFailedToLoad = () => ({
  type: FS_CHECKOUT_FAILED_TO_LOAD
});

export const fsCheckoutError = error => ({
  type: FS_CHECKOUT_ERROR,
  error
});

export const fsChangeSelectedProduct = path => ({
  type: FS_CHANGE_SELECTED_PRODUCT,
  path
});

export const fsClosePopoverModal = () => ({
  type: FS_CLOSE_POPOVER_MODAL
});

export const fsLinkOut = () => ({
  type: FS_LINK_OUT
});
